import React from 'react';

import { Icon } from '@shared/ui';
import { iconsData } from '@shared/ui/DnD/model/iconsData';

interface IFileItemSvgProps {
    extension: string;
    iconWidth?: number;
    iconHeight?: number;
}

export const FileItemSvg = ({ extension, iconWidth = 40, iconHeight = 40 }: IFileItemSvgProps) => {
    const foundedIconItem = iconsData.find((obj) => obj.extension === extension);
    if (!foundedIconItem)
        return <Icon iconName="fileItemPlaceholder" width={iconWidth} height={iconHeight} />;
    return <Icon iconName={foundedIconItem.iconName} width={iconWidth} height={iconHeight} />;
};
